<template lang="pug">
.login-email-password 
    v-label.login-email-password--heading Allons-y ! 🙌
    v-form(ref="otpForm")
        .info() Contactez-nous afin de pouvoir vous connecter.
        div()
          .login-otp--input-container
            v-otp-input(
              length=8
              :error="otpInError"
              type='number'
              v-model='otp'
              :rules="[isRequired, isOTP]"
              @update:modelValue='()=>{otpError = false; otpInError = false;}'
            )
          .login-otp--input-container__error-message(v-if="otpInError")
            .otp-message OTP invalide
        v-btn.login-email-password--button(variant="text" @click="validateOTP")
            v-icon(right) epoca:loginKey
            v-label.login-email-password--button__label Se connecter
</template>

<script setup lang="ts">
import { OAuthProvider, getAuth, signInWithCredential, signInWithCustomToken } from 'firebase/auth'

const navigationStore = useNavigationStore()
const emailOrRpps = ref('')
const password = ref('')
const otp = ref('')
const credentialSent = ref(false)
const mfa = ref('')
const fASent = ref(false)
const otpError = ref(false)
const otpInError = ref(false)
const isRenewPassword = ref(false)
const showPassword = ref(false)
const isEmailAuthent = ref(false)
const loginForm: any = ref(null)
const otpForm: any = ref(null)
const info = ref('')
const otpSent = ref(false)
const showPasswordInput = ref(false)
const recaptchaSuccess = ref(false)
const pscCibaCode = ref<string>('')
const isApplyRecaptcha = ref(null)
const rememberMe = ref(false)
const emailError = ref({
  isValid: true,
  message: '',
})

const passwordError = ref({
  isValid: true,
  message: '',
})

const systemSettings = ref<any>(null)

const { sendEmailAndPassword, sendSMSCode, sentResetPasswordLink, applyRecaptcha, multiFactorWithSMS, sendPhoneNumber } =
  useAuth()

const isLoginProgress = computed(() => {
  return userStore.isLoginProgress
})
const rpps = ref('')
const userStore = useUserStore()

const checkOTP = (t: any) => {
  otpError.value = t.toString().length !== 8
}

const { $toast: toast, $api: api } = useNuxtApp()
const isRequired = (v: string) => v?.length > 0 || 'Ce champ est obligatoire'

const isOTP = (v: string) => {
  return v.length === 8 || 'Le format est incorrect'
}

const goToLogin = () => {
  navigateTo('/')
}

const validateOTP = async () => {
  const { valid, errors } = await otpForm.value?.validate()
  if (valid && !otpError.value) {
    try {
      const result = await api.auth.loginWithOTP(otp.value)
      const auth = await getAuth()
      const firebaseResponse = await signInWithCustomToken(auth, result.customToken)
      navigationStore.setExternalContext()
      const currentToken = await firebaseResponse.user.getIdToken()
      const userStore = useUserStore()
      api.setToken(currentToken)
      userStore.save(firebaseResponse.user, currentToken, 'token')
    } catch (error) {
      console.error('Error during OTP validation:', error)
      otpInError.value = true
      otpError.value = true
    }
  }
}

onMounted(async () => {
  systemSettings.value = await api.cms.getConfig()
})
</script>

<style lang="stylus" scoped>
.login-email-password
  align-items flex-start
  display flex
  flex-direction column
  flex 1
  gap 80px
  .info
    color: var(--Text-6, #3B3B3B)
    body-b4-medium()
    &--contact
      margin-top 8px
      color: var(--Text-6, #3B3B3B)
      body-b5-semibold()
  &--remember-modify-password
    display flex
    justify-content space-between
    :deep().v-checkbox
      .v-selection-control
        align-items: center;
        justify-content: center;
        display: flex;
        gap 4px
        min-height: auto;
        &__wrapper
          height: 18px;
          width: 18px;
        .v-icon
          font-size: 16px;
          color var(--Text-6, #3B3B3B)
  &--input-container
    position relative
    &[data-type='password']
      :deep().v-field
        input
          padding-right 80px
    :deep().v-input
      &__details
        color var(--Primary-Warning, #FF4D6A)
        padding-left 0
        body-b3-regular()
    :deep().v-field
      border-radius 4px
      background var(--Textfield-Input-BG-Dark, rgba(0, 0, 0, 0.08)) !important
      border-left 4px solid transparent
      &__outline
        display none
      &--error
        border-left 4px solid var(--Primary-Warning, #FF4D6A)
      .v-label.v-field-label
        margin-left 8px
        padding-right 25px
        color var(--Text-4, #747474)
        body-b3-medium()
      input
        padding-left 8px
        padding-right 50px
        color var(--Text-8, #1F1F1F)
        body-b3-medium()
        &[type="password"]
          font-family caption
          font-size: 20px;
    &__password-icon
      position absolute
      cursor pointer
      top: 10px;
      right: 42px;
      height: 20px;
      display: flex
      align-items: center;
      justify-content: center;
      .v-icon
        height 20px
        width 20px
        font-size: 20px;
        color var(--Text-4, #747474)
    &__icon
      position absolute
      top: 10px;
      right: 8px;
      height: 20px;
      padding-left: 5px;
      border-left 1px solid var(--Text-3, #A4A4A4)
      display: flex
      align-items: center
      justify-content: center
      .v-icon
        height 20px
        width 20px
        font-size: 20px;
        color var(--Text-4, #747474)

  &--button
    display: flex;
    height: 40px;
    padding: 0px 24px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    width: 100%;
    border-radius: 4px;
    background: var(--Primary-Brand-Lime, #97FF8C);
    &:hover
      background: linear-gradient(to bottom, #97FF8C 0%, #6EE7B7 100%);
    &__label
      color: var(--Text-8, #1F1F1F)
      body-b3-semibold()
      opacity 1
    :deep().v-btn
      &__content
        gap: 8px;
  &--password-reset
    color var(--Text-6, #3B3B3B)
    padding 0
    height auto
    &__label
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
      cursor pointer
      opacity 1
      text-transform none
  &--goback-btn
    color var(--Text-6, #3B3B3B)
    padding 0
    height auto
    &__label
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
      cursor pointer
      opacity 1
      text-transform none
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
  &--heading
    color: var(--Text-8, #1F1F1F)
    title-t3-uppercase()
    opacity 1
  .psc-ciba-code
    display: flex
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .heading
      color: var(--Text-3, #A4A4A4);
      body-b5-regular()
      margin-bottom: 16px;
    .code
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 8px;
      background: var(--Interface-Pearl, #EDEDED);
      color: #000;
      leading-trim: both;
      text-edge: cap;
      font-family: Roboto;
      font-size: 64px;
      font-style: normal;
      font-weight: 600;
      line-height: 100%; /* 64px */
      text-transform: uppercase;
  .v-form
    display flex
    width: 100%;
    gap 32px
    flex-direction column
    .input-container
      display flex
      flex-direction column
      gap 10px
    .login-otp
      &--input-container
        &__error-message
          color var(--Primary-Warning, #FF4D6A)
          body-b5-regular()
        :deep().v-otp-input
          padding-top 0
          &__content
            height: 56px;
            padding: 0.5rem 0;
        :deep().v-field
          border-radius 4px
          background var(--Textfield-Input-BG-Dark, rgba(0, 0, 0, 0.08)) !important
          &__outline
            display none
          input
            color var(--Text-8, #1F1F1F)
            otp-n3-bold()
        .otp-message
          white-space inherit
  h3
    margin-top 20px
</style>
